import { useVisibilityState } from '@lbcamden/lib-react';
import { useCallback, useState } from 'react';

import { PcfraPerson } from '~/common/types/people';

import { LogActivityDialog } from './LogActivityDialog';

export const useLogActivityDialog = () => {
  const [person, setPerson] = useState<PcfraPerson>();

  const { show, hide, visible } = useVisibilityState();

  const showLogActivityDialog = useCallback((selectedPerson: PcfraPerson) => {
    setPerson(selectedPerson);
    show();
  }, []);

  return {
    showLogActivityDialog,
    logActivityDialog: <LogActivityDialog open={visible} person={person} onClose={hide} />,
  };
};
